const AUTH_STORAGE_KEY =
  process.env.REACT_APP_AUTH_STORAGE_KEY || 'esmart.auth.token';
const AUTH_REMEMBER_STORAGE_KEY =
  process.env.REACT_APP_AUTH_REMEMBER_STORAGE_KEY || 'esmart.auth.remember';

let memoryToken: string | null = null;

const safeGet = (storage: Storage, key: string): string | null => {
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
};
const safeSet = (storage: Storage, key: string, value: string): void => {
  try {
    storage.setItem(key, value);
  } catch {
    // Storage may be blocked in an embedded/private browser context.
  }
};
const safeRemove = (storage: Storage, key: string): void => {
  try {
    storage.removeItem(key);
  } catch {
    // Storage may be blocked in an embedded/private browser context.
  }
};

export const getAccessToken = (): string | null =>
  memoryToken ||
  safeGet(window.sessionStorage, AUTH_STORAGE_KEY) ||
  safeGet(window.localStorage, AUTH_STORAGE_KEY);

/** Query tokens are intentionally memory-only and do not erase stored login state. */
export const setMemoryAccessToken = (token: string): void => {
  memoryToken = token.trim() || null;
};

/** Login tokens use exactly one persistent store; stale entries are removed first. */
export const persistAccessToken = (token: string, remember: boolean): void => {
  clearAccessToken();
  memoryToken = token.trim();
  const storage = remember ? window.localStorage : window.sessionStorage;
  safeSet(storage, AUTH_STORAGE_KEY, memoryToken);
  safeSet(storage, AUTH_REMEMBER_STORAGE_KEY, String(remember));
};

export const clearAccessToken = (): void => {
  memoryToken = null;
  [window.sessionStorage, window.localStorage].forEach((storage) => {
    safeRemove(storage, AUTH_STORAGE_KEY);
    safeRemove(storage, AUTH_REMEMBER_STORAGE_KEY);
  });
};
